export default [
    {
        "id": "report-content",
        "html": require('./report-content/html').default,
        "css": require('./report-content/css').default,
        "cssTablet": require('./report-content/cssTablet').default,
        "cssMobile": require('./report-content/cssMobile').default,
        "scss": require('./report-content/scss').default,
        "scssTablet": require('./report-content/scssTablet').default,
        "scssMobile": require('./report-content/scssMobile').default
    }
]